import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["es"],
  defaultLocale: "es",
  // 'always' para static export - URLs siempre con prefijo de locale /es/...
  localePrefix: "always",
});

// Export helpers para navigation
export type Locale = (typeof routing.locales)[number];
